import {
  CompanyLegalBeneficiary,
  OnboardingCompanyProfile,
  UserProfile,
} from '__generated__/GQL';
import getCurrentLegalBeneficiary from 'features/Onboarding/lib/getCurrentLegalBeneficiary';
import getIsEi from 'features/Onboarding/lib/getIsEi';
import { ApplicantType } from 'features/Onboarding/types';

import getComplianceStatus from '../../Compliance/libs/getComplianceStatus';
import getPersonalAddressModuleStatus from '../../PersonalAddress/lib/getModuleStatus';
import { VerificationStatus } from '../../Verification/lib/steps/types';

import { getHasAlreadyFilledProfile } from '.';

const getIsBusinessRoleCompleted = ({
  companyLegalBeneficiaries,
  companyProfile,
}: {
  companyProfile: Pick<OnboardingCompanyProfile, 'legalForm'>;
  companyLegalBeneficiaries: Pick<
    CompanyLegalBeneficiary,
    | 'companyLegalBeneficiaryId'
    | 'isCurrentUser'
    | 'isDirector'
    | 'isMajorShareholder'
  >[];
}): boolean => {
  const isEi = getIsEi(companyProfile);
  const currentLegalBeneficiary = getCurrentLegalBeneficiary(
    companyLegalBeneficiaries,
  );

  return (
    isEi ||
    currentLegalBeneficiary?.isDirector === true ||
    currentLegalBeneficiary?.isMajorShareholder === true
  );
};

const isPersonalInfoModuleCompleted = ({
  applicantType,
  companyLegalBeneficiaries,
  companyProfile,
  userProfile,
}: {
  userProfile: Pick<
    UserProfile,
    | 'uid'
    | 'email'
    | 'hasFinishedProfileSetup'
    | 'isEligibleToOnboard'
    | 'isComplianceFilled'
    | 'firstName'
    | 'lastName'
    | 'gender'
    | 'street'
    | 'city'
    | 'zip'
    | 'country'
  >;
  companyProfile: Pick<OnboardingCompanyProfile, 'legalForm'>;
  companyLegalBeneficiaries: Pick<
    CompanyLegalBeneficiary,
    | 'companyLegalBeneficiaryId'
    | 'isCurrentUser'
    | 'isDirector'
    | 'isMajorShareholder'
  >[];
  applicantType: ApplicantType;
}): boolean => {
  const hasFilledProfile = getHasAlreadyFilledProfile(userProfile);

  const isBusinessRoleCompleted = getIsBusinessRoleCompleted({
    companyLegalBeneficiaries,
    companyProfile,
  });

  const isPersonalAddressCompleted =
    getPersonalAddressModuleStatus({ applicantType, userProfile }) ===
    VerificationStatus.Completed;

  const isComplianceCompleted =
    getComplianceStatus({ applicantType, userProfile }) ===
    VerificationStatus.Completed;

  return (
    hasFilledProfile &&
    isBusinessRoleCompleted &&
    isPersonalAddressCompleted &&
    isComplianceCompleted
  );
};

export default isPersonalInfoModuleCompleted;
